export default __webpack_public_path__ + "static/media/blog-add.265aaf4f.png";